function FolderOperations() {
  return (
    <div className='row mb-3'>
      <div className='col-xl-10'></div>
      <div className='d-flex flex-row-reverse col-xl-2'></div>
    </div>
  )
}

export default FolderOperations
